// @flow

import React, { PureComponent, createContext } from 'react';
import { includes } from 'lodash';
import { addUrlProps, UrlQueryParamTypes } from 'react-url-query';

type Props = {
  fromDate: string,
  onChangeFromDate: (fromDate: string) => any,
  toDate: string,
  onChangeToDate: (toDate: string) => any,

  country: string,
  onChangeCountry: (country: string) => any,

  platform: string,
  onChangePlatform: (platform: string) => any,

  children?: any,
};

type State = {
  fromDate: string,
  toDate: string,
  setPeriodDays: (fromDate: string, toDate: string) => any,

  country: string,
  setCountry: (country: string) => any,

  platform: string,
  setPlatform: (platform: string) => any,
};

const urlPropsQueryConfig = {
  fromDate: {
    type: UrlQueryParamTypes.string,
  },
  toDate: {
    type: UrlQueryParamTypes.string,
  },
  country: {
    type: UrlQueryParamTypes.string,
    validate: value => includes(['', 'MD', 'NOT_MD'], value),
  },
  platform: {
    type: UrlQueryParamTypes.string,
    validate: value => includes(['', 'DESKTOP', 'MOBILE'], value),
  },
};

const initialProps = {
  fromDate: undefined,
  toDate: undefined,
  setPeriodDays: (fromDate: string, toDate: string) => {},

  country: undefined,
  setCountry: (country: string) => {},

  platform: undefined,
  setPlatform: (platform: string) => {},
};

const { Provider, Consumer } = createContext({
  ...initialProps,
});

class CommonFiltersContainer extends PureComponent<Props, State> {
  static defaultProps = initialProps;

  constructor(props) {
    super(props);

    this.state = {
      fromDate: props.fromDate,
      toDate: props.toDate,
      setPeriodDays: this.setPeriodDays,

      country: props.country,
      setCountry: this.setCountry,

      platform: props.platform,
      setPlatform: this.setPlatform,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { fromDate, toDate, country, platform } = nextProps;

    return {
      ...prevState,
      fromDate,
      toDate,
      country,
      platform,
    };
  }

  setPeriodDays = (fromDate: string, toDate: string) => {
    this.props.onChangeFromDate(fromDate);
    this.props.onChangeToDate(toDate);
  };

  setCountry = (country: string) => {
    this.props.onChangeCountry(country);
  };

  setPlatform = (platform: string) => {
    this.props.onChangePlatform(platform);
  };

  render() {
    return <Provider value={this.state}>{this.props.children}</Provider>;
  }
}

export { Consumer as CommonFiltersConsumer };

export default addUrlProps({ urlPropsQueryConfig })(CommonFiltersContainer);
